export default __webpack_public_path__ + "static/media/ELpending.6679af1c.svg";